import Vue from 'vue'

const RenameInstance = Vue.extend(require('./rename.vue').default);
let instance = null
let renamePromise = null
let renameResolve = null

let getInstance = () => {
  return new RenameInstance({
    el: document.createElement('div')
  })
}

let close = () => {
  instance.close()
  instance.$el.parentNode.removeChild(instance.$el);
  instance = null
  if (renameResolve) {
    renameResolve(null)
    renameResolve = null
  }
  renamePromise = null
}

let Rename = (content) => {
  if (instance) {
    close()
  }
  instance = getInstance()

  document.body.appendChild(instance.$el);
  renamePromise = new Promise((resolve, reject) => {
    renameResolve = resolve
  })
  instance.open(content, renameResolve)

  return renamePromise
}

export default Rename
